import React, { useState } from 'react';

export default function BrandLogo({
  src,
  alt,
  imgClassName = '',
  fallbackClassName = '',
  light = false,
  loading,
  decoding,
  fetchPriority,
  width,
  height,
  sizes,
}) {
  const [erroImg, setErroImg] = useState(false);

  if (!src || erroImg) {
    return (
      <div className={fallbackClassName || 'flex flex-col leading-none'}>
        <span className="font-semibold text-base tracking-widest uppercase" style={{ color: '#B89547', letterSpacing: '0.12em' }}>Marcia Monteiro</span>
        <span className={`text-xs tracking-[0.3em] uppercase font-medium ${light ? 'text-stone-400' : 'text-stone-500'}`}>Wellness</span>
      </div>
    );
  }

  return (
    <img
      src={src}
      alt={alt}
      className={imgClassName}
      loading={loading}
      decoding={decoding}
      fetchPriority={fetchPriority}
      width={width}
      height={height}
      sizes={sizes}
      onError={() => setErroImg(true)}
    />
  );
}
